module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-9.a1de1442.jpg";